'use es6';

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
const getReportNameError = reportName => reportName.length === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reporting-action-components.actions.save.modal.validation.blankReportName"
}) : null;
const ReportNameField = ({
  onChange,
  onValidationError = noop,
  reportName = ''
}) => {
  const [error, setError] = useState(null);
  useEffect(() => {
    onValidationError(getReportNameError(reportName));
  }, [onValidationError, reportName]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.save.modal.reportName"
    }),
    required: true,
    error: !!error,
    validationMessage: error,
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "report-save-name",
      onChange: ({
        target: {
          value: name
        }
      }) => {
        onChange(name);
        setError(getReportNameError(name));
      },
      value: reportName
    })
  });
};
ReportNameField.propTypes = {
  onChange: PropTypes.func.isRequired,
  onValidationError: PropTypes.func,
  reportName: PropTypes.string
};
export default ReportNameField;